import * as React from 'react';
import {
  gridPageCountSelector,
  gridPaginationSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid-pro';
import {Paginator} from 'components/paginator';
import type {PaginationModel} from '../types';

export function DataGridPaginator(
  setPaginationModel: (model: PaginationModel) => void,
  scrollAfterPagination?: boolean,
) {
  const apiRef = useGridApiContext();

  const {paginationModel} = useGridSelector(apiRef, gridPaginationSelector);
  const pages = useGridSelector(apiRef, gridPageCountSelector);

  const previousDisabled = paginationModel.page <= 0;
  const nextDisabled = paginationModel.page + 1 >= pages;

  return (
    <Paginator
      indicatorText={`${paginationModel.page + 1} / ${pages}`}
      previousDisabled={previousDisabled}
      previousOnClick={() => {
        if (!previousDisabled) {
          if (scrollAfterPagination) {
            // Scrolls to top of table.
            scroll({
              behavior: 'smooth',
              top: Math.floor(
                (apiRef.current.rootElementRef.current?.getBoundingClientRect()
                  .top ?? 0) +
                  window.scrollY -
                  85, // 85px for header height
              ),
            });
          }

          setPaginationModel({
            ...paginationModel,
            page: paginationModel.page - 1,
          });
        }
      }}
      nextDisabled={nextDisabled}
      nextOnClick={() => {
        if (!nextDisabled) {
          if (scrollAfterPagination) {
            // Scrolls to top of table.
            scroll({
              behavior: 'smooth',
              top: Math.floor(
                (apiRef.current.rootElementRef.current?.getBoundingClientRect()
                  .top ?? 0) +
                  window.scrollY -
                  85, // 85px for header height
              ),
            });
          }

          setPaginationModel({
            ...paginationModel,
            page: paginationModel.page + 1,
          });
        }
      }}
    />
  );
}
